// Marker attribute placed on selectable data cells (see Cell.tsx). The value
// is a per-table scope id (from useId()) that identifies which table owns the
// cell. A mousedown whose target's closest selectable ancestor carries a
// different scope id (or none) is treated as "outside this table's cells" and
// clears that table's selection.
export const CELL_SELECTABLE_ATTRIBUTE = 'data-fdt-cell-selectable';
export const CELL_SELECTED_ATTRIBUTE = 'data-fdt-cell-selected';
export const FILL_HANDLE_ATTRIBUTE = 'data-fdt-fill-handle';

// Set on the <table> element for the duration of a cell-range drag that has
// crossed into another cell. Drives a `user-select: none` rule so the drag
// highlights cells rather than text, while leaving text selectable inside a
// single cell when no drag is under way (see
// useSuppressTextSelectionWhileCellDrag).
export const CELL_DRAG_ACTIVE_ATTRIBUTE = 'data-fdt-cell-drag-active';

// Which outer edges of the selection region this cell sits on. An empty string
// means the cell is interior (no edges). null means not selected at all.
// Values are substrings of "trbl" (top/right/bottom/left).
export const CELL_EDGES_ATTRIBUTE = 'data-fdt-cell-edges';